import React, { useState, useRef } from "react";
import Webcam from "react-webcam";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

const IDCapture = ({ name, label, formData, setFormData, completeLabel }) => {
    const [showModal, setShowModal] = useState(false);
    const [showWebcam, setShowWebcam] = useState(false);
    const [capturedImage, setCapturedImage] = useState(formData?.[name] || "");
    const fileInputRef = useRef(null);
    const webcamRef = useRef(null);

    // Handle image upload
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setCapturedImage(reader.result);
                setFormData((prev) => ({ ...prev, [name]: reader.result }));
            };
            reader.readAsDataURL(file);
        }
        setShowModal(false);
    };

    // Capture image from webcam
    const captureImage = () => {
        if (webcamRef.current) {
            const imageSrc = webcamRef.current.getScreenshot();
            if (imageSrc) {
                setCapturedImage(imageSrc);
                setFormData((prev) => ({ ...prev, [name]: imageSrc }));
                setShowWebcam(false);
                setShowModal(false);
            }
        } else {
            console.error("Webcam reference is not available.");
        }
    };

    return (
        <div className="tw-w-full">
            {/* Image Upload Section */}
            <div
                className="tw-border-2 tw-relative tw-bg-cover tw-bg-center tw-border-dashed tw-bg-white tw-w-full tw-min-h-[240px] max-sm:tw-min-h-[180px] hover:tw-border-gray-600 tw-rounded-lg tw-mb-4 tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-cursor-pointer tw-border-emerald-500 tw-transition-colors"
                onClick={() => setShowModal(true)}
                style={{ backgroundImage: `url(${capturedImage})` }}
            >
                {!capturedImage ? (
                    <span>
                        <div className="tw-flex tw-justify-center tw-mb-4">
                            <p className="tw-text-sm max-sm:tw-text-xs tw-text-gray-500 tw-mb-2 tw-px-2">
                                {completeLabel || `Choose or Capture ID ${label}`}
                            </p>
                        </div>
                        <button className="tw-py-2 tw-px-4 max-sm:tw-px-3 max-sm:tw-py-3 tw-rounded-md tw-mb-4 hover:tw-bg-primary_hover tw-bg-primary_hard tw-text-white tw-transition-colors max-sm:tw-text-sm">
                            Select Image
                        </button>
                    </span>
                ) : (
                    <span className="tw-h-full tw-flex tw-items-center tw-justify-center tw-w-full">
                        <button className="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-text-white tw-py-2 tw-px-4 tw-rounded-md tw-transition-opacity tw-opacity-0 hover:tw-opacity-100">
                            <span className="tw-border-1 tw-border-white tw-px-4 tw-py-2 tw-rounded-md">Retake Image</span>
                        </button>
                    </span>
                )}
            </div>

            {/* Modal for selecting Upload or Webcam */}
            <Modal open={showModal} onClose={() => setShowModal(false)} className="tw-flex tw-justify-center tw-items-center tw-p-4">
                <Box className="tw-bg-white tw-rounded-lg tw-shadow-lg tw-p-6 max-sm:tw-p-4 tw-w-96 max-sm:tw-w-full max-sm:tw-max-w-[90vw] tw-mx-auto tw-mt-20 max-sm:tw-mt-10 tw-max-h-[90vh] tw-overflow-y-auto">
                    {showWebcam ? (
                        <div className="tw-flex tw-flex-col tw-items-center">
                            <Webcam
                                audio={false}
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                className="tw-rounded-lg tw-mb-4 tw-w-full max-sm:tw-max-w-[280px]"
                            />
                            <button
                                onClick={captureImage}
                                className="tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 max-sm:tw-py-3 tw-rounded-lg tw-mb-4 tw-w-full max-sm:tw-text-sm"
                            >
                                Capture Photo
                            </button>
                            <button
                                onClick={() => setShowWebcam(false)}
                                className="tw-bg-gray-400 tw-text-white tw-py-2 tw-px-4 max-sm:tw-py-3 tw-rounded-lg tw-w-full max-sm:tw-text-sm"
                            >
                                Cancel
                            </button>
                        </div>
                    ) : (
                        <div className="tw-flex tw-flex-col tw-space-y-4 max-sm:tw-space-y-3">
                            <button
                                onClick={() => fileInputRef.current?.click()}
                                className="tw-bg-blue-500 tw-text-white tw-py-2 tw-px-4 max-sm:tw-py-3 tw-rounded-lg tw-w-full max-sm:tw-text-sm"
                            >
                                Upload Image
                            </button>
                            <button
                                onClick={() => setShowWebcam(true)}
                                className="tw-bg-green-500 tw-text-white tw-py-2 tw-px-4 max-sm:tw-py-3 tw-rounded-lg tw-w-full max-sm:tw-text-sm"
                            >
                                Use Webcam
                            </button>
                            <button
                                onClick={() => setShowModal(false)}
                                className="tw-bg-gray-400 tw-text-white tw-py-2 tw-px-4 max-sm:tw-py-3 tw-rounded-lg tw-w-full max-sm:tw-text-sm"
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                    <input type="file" ref={fileInputRef} className="tw-hidden" onChange={handleFileUpload} accept="image/*" />
                </Box>
            </Modal>
        </div>
    );
};

export default IDCapture;
